<template>
    <div class="panel panel-default">
        <table class="table table-striped table-bordered">
            <thead>
            <tr>
                <th scope="col">#</th>
                <th v-for="location in locations" v::key="location.id" scope="col">{{ location.name }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="day in days">
                <td scope="row">{{ day }}</td>

                <template v-for="location in locations">
                    <td>
                        <div v-if="getAppointment(day, location.id)">
                            <a @click="selectAppointment(getAppointment(day, location.id))"
                               style="cursor:pointer;">
                                #{{ getAppointment(day, location.id).id }} foglalás
                            </a>
                        </div>
                        <div v-if="getEvent(day, location.id)">
                            #{{ getEvent(day, location.id).id }} esemény ({{ getEvent(day, location.id).note }})
                        </div>
                    </td>
                </template>
            </tr>
            </tbody>
        </table>

        <modal v-if="! hidden">
            <div slot="header">
                <slot name="title">
                    #{{ selectedAppointment.id }} foglalás
                </slot>
            </div>
            <div slot="body">
                <div>
                    <ul class="unstyled">
                        <li>
                            <span class="icon-wrapper">
                                <i class="fa fa-map-marker"></i>
                            </span>
                            {{ selectedAppointment.location.name }}
                        </li>
                        <li>
                            <span class="icon-wrapper">
                                <i class="fa fa-users"></i>
                            </span>
                            {{ selectedAppointment.user.name }} - ({{ selectedAppointment.persons }} fő)
                        </li>
                        <li>
                            <span class="icon-wrapper">
                                <i class="fa fa-ticket"></i>
                            </span>
                            {{ selectedAppointment.ticket }}
                        </li>
                        <li v-if="selectedAppointment.paymentMethod === 'credit_card'">
                            <span class="icon-wrapper">
                                <i class=" fa fa-credit-card"></i>
                            </span>
                            Kártyás fizetés ({{ selectedAppointment.payed ? 'Fizetve' : 'Még nincs kifizetve' }})
                        </li>
                        <li v-else>
                            <span class="icon-wrapper">
                                <i class="fa fa-money"></i>
                            </span>
                            Készpénzes fizetés
                        </li>
                        <li>
                            <span class="icon-wrapper">
                                <i class="fa fa-dollar"></i>
                            </span>
                            {{ selectedAppointment.price }} {{ selectedAppointment.currency }}
                        </li>
                        <li>
                            <div>
                                <span class="icon-wrapper">
                                    <i class="fa fa-minus-circle"></i>
                                </span>
                                {{ selectedAppointment.statusLabel }}
                            </div>
                        </li>
                        <li>
                            <span class="icon-wrapper">
                                <i class="fa fa-calendar"></i>
                            </span>
                            {{ getDate() }}
                        </li>
                    </ul>
                </div>
            </div>

            <div slot="footer">
                <div v-if="this.selectedAppointment.links.hasOwnProperty('delete')" class="btn btn-danger"
                     @click="deleteAppointment" :disabled="deleting">
                    <slot name="submit">
                        Törlés
                    </slot>
                </div>
                <div v-if="isEnabledRejecting()" class="btn btn-danger"
                     @click="decline = true" :disabled="decline">
                    <slot name="submit">
                        Elutasítás
                    </slot>
                </div>
                <div class="btn btn-default" @click="hidden = true">
                    <slot name="close">
                        Bezárás
                    </slot>
                </div>
                <div v-if="isEnabledAccepting()" class="btn btn-success"
                     @click="acceptingAppointment" :disabled="accepting">
                    Jóváhagyás
                </div>
                <div v-if="decline">
                    <div>
                        <div class="modal-body">
                            <label for="reason">Az elutasítás oka</label>
                            <textarea id="reason" name="reason" style="width: 100%; height: 10rem"></textarea>
                        </div>
                    </div>
                    <div class="btn btn-danger" @click="rejectingAppointment" :disabled="rejecting">
                        Foglalás elutasítása
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import moment from "moment";
    import axios  from "axios";
    import _      from "lodash";

    export default {
        name: "AppointmentSummary",

        props: ["locations", "appointments", "events", "month"],

        data() {
            return {
                rejecting: false,
                deleting: false,
                selectedAppointment: {
                    id: "",
                    location: {
                        name: ""
                    },
                    user: {
                        name: ""
                    },
                    ticket: "",
                    price: "",
                    persons: 1,
                    currency: "",
                    from: moment(),
                    until: moment()
                },
                decline: false,
                hidden: true,
                accepting: false
            };
        },

        methods: {
            selectAppointment(appointment) {
                this.selectedAppointment = appointment;

                this.hidden = false;
            },

            rejectingAppointment() {
                this.rejecting = true;

                axios
                    .post(this.selectedAppointment.links.reject, {
                        reason: document.getElementById("reason").value
                    })
                    .then(() => {
                        this.selectedAppointment.status = "rejected";
                        this.removeAppointment()
                        this.rejecting = false;
                        this.decline = false;
                        this.hidden = true;
                    });
            },

            deleteAppointment() {
                this.deleting = true;

                axios.delete(this.selectedAppointment.links.delete).then(() => {
                    this.deleting = false;
                    this.hidden = true;
                    this.removeAppointment()
                }, () => {
                    this.deleting = false;
                    this.hidden = true;
                    this.removeAppointment()
                });
            },

            isEnabledRejecting() {
                return (
                    this.selectedAppointment.status === "pending" &&
                    this.selectedAppointment.links.hasOwnProperty("reject") &&
                    moment() < moment(this.selectedAppointment.from) &&
                    moment(this.selectedAppointment.from).diff(moment(), "hours") >= 24
                );
            },

            isEnabledAccepting() {
                return (
                    this.selectedAppointment.status === "pending" &&
                    this.selectedAppointment.links.hasOwnProperty("accept") &&
                    moment() < moment(this.selectedAppointment.from)
                );
            },

            removeAppointment() {
                this.appointments.splice(this.appointments.indexOf(this.selectAppointment), 0)
                location.reload()
            },

            acceptingAppointment() {
                this.accepting = true;
                axios.post(this.selectedAppointment.links.accept).then(() => {
                    this.selectedAppointment.status = "accepted";
                    this.accepting = false;
                    this.hidden = true;
                });
            },

            getDate() {
                if ($.isEmptyObject(this.selectedAppointment)) return "";

                let date = moment(this.selectedAppointment.from).format("YYYY-MM-DD");

                return $.isEmptyObject(this.selectedAppointment.until)
                    ? date
                    : `${date} - ${moment(this.selectedAppointment.until)
                        .subtract(1, "day")
                        .format("YYYY-MM-DD")}`;
            },

            getAppointment(day, location) {
                day = moment(`${this.month}-${day.toString().padStart(2, "0")}`);

                let appointment = this.appointments.filter(appointment => {
                    return (
                        day >= moment(appointment.from) &&
                        day <= moment(appointment.until).subtract(1, "day") &&
                        appointment.location.id === location
                    );
                });

                return appointment.length > 0 ? appointment[0] : null;
            },

            getEvent(day, location) {
                day = moment(`${this.month}-${day.toString().padStart(2, "0")}`);

                let event = this.events.filter(event => {
                    return (
                        day >= moment(event.valid_from) &&
                        day <= moment(event.valid_to) &&
                        event.location_id === location
                    );
                });

                return event.length > 0 ? event[0] : null;
            }
        },

        created() {
            this.days = _.range(1, moment(this.month).daysInMonth() + 1, 1);
        }
    };
</script>

<style scoped>
    .table-striped > tbody > tr:nth-of-type(odd) {
        background-color: #f0f0f0;
    }

    ul.unstyled {
        padding-left: 0;
        list-style-type: none;
    }

    .icon-wrapper {
        width: 1em;
        text-align: center;
        display: inline-block;
        margin-right: 0.75em;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/AppointmentSummary.vue